module.exports = __webpack_public_path__ + "static/media/oops.494b0d36.svg";